'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';

export function BaseMenuTimerView(props) {
  return !props.hasTimers ? null : (
    <div className={classNames('MenuTimer', props.className)}>
      <div className="MenuTimer__header">
        {props.headerLabel}
      </div>
      <div className="MenuTimer__breakdown">
        {`${props.active} ${props.activeLabel}, ${props.paused} ${props.pausedLabel}`}
      </div>
    </div>
  );
}

BaseMenuTimerView.propTypes = {
  className: T.string,

  active: T.number,
  paused: T.number,
  hasTimers: T.bool,

  activeLabel: T.string,
  pausedLabel: T.string,
  headerLabel: T.string,
};

BaseMenuTimerView.defaultProps = {
  activeLabel: 'Timers',
  pausedLabel: 'Active',
  headerLabel: 'Paused',
};

export const MenuTimerView = I18nComponent(BaseMenuTimerView, [
  {code: 'timers.menu.header.label', prop: 'headerLabel'},
  {code: 'timers.menu.active.label', prop: 'activeLabel'},
  {code: 'timers.menu.paused.label', prop: 'pausedLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/timers/components/MenuTimer/MenuTimerView.js